import React, {FC, useEffect} from "react";
import {Form, Field} from "react-final-form";
import {InputText} from "primereact/inputtext";
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {classNames} from "primereact/utils";
import "./CreateRequest.css";
import {Image} from "primereact/image";
import {useAppDispatch, useAppSelector} from "../../../app/hooks";
import {
    initialReplacementRequestState,
    selectSomethingState,
    setData, setReplacementRequestProperty
} from "../../../slices/tmpPatternSlice";
import {Message} from "primereact/message";
import {useNavigate} from "react-router-dom";
import {routes} from "../../../app/routes";
import {ProgressSpinner} from "primereact/progressspinner";
import {useCreateReplacementRequestMutation} from "../../../api/refereeReplacementApi";

export const CreateRequest: FC = () => {
    const navigate = useNavigate();

    const validate = (data: any) => {
        let errors: any = {};

        if (!data.matchUrl) {
            errors.firstName = "Pole jest obowiązkowe";
        }

        if (!data.refereeEmail) {
            errors.refereeEmail = "Pole jest obowiązkowe";
        } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(data.refereeEmail)) {
            errors.refereeEmail = "Nieprawidłowy adres email";
        }

        if (!data.replacementType) {
            errors.replacementType = "Pole jest obowiązkowe";
        }

        return errors;
    };

    const onCreateRequestSubmit = (data: any, form: any) => {
        dispatch(setReplacementRequestProperty({property: "matchUrl", value: data.matchUrl}));
        dispatch(setReplacementRequestProperty({property: "refereeEmail", value: data.refereeEmail}));
        dispatch(setReplacementRequestProperty({property: "replacementType", value: data.replacementType}));
        dispatch(setReplacementRequestProperty({property: "additionalInformation", value: data.additionalInformation}));

        createReplacementRequest({
            replacementRequestDto: {
                matchUrl: data.matchUrl,
                refereeEmail: data.refereeEmail,
                replacementType: data.replacementType,
                additionalInformation: data.additionalInformation
            }
        });
    };

    const isFormFieldValid = (meta: any) => !!(meta.touched && meta.error);
    const getFormErrorMessage = (meta: any) => {
        return isFormFieldValid(meta) && <small className="p-error font-bold">{meta.error}</small>;
    };

    const dispatch = useAppDispatch();

    const [createReplacementRequest, {
        isSuccess: isCreateReplacementRequestSuccess,
        isLoading: isCreateReplacementRequestLoading,
        isError: isCreateReplacementRequestError,
        error
    }] = useCreateReplacementRequestMutation();

    const {replacementRequest} = useAppSelector(selectSomethingState);

    // @ts-ignore
    const errorMessage = error?.data?.message;

    useEffect(() => {
        if (isCreateReplacementRequestSuccess) {
            navigate(`/${routes.SUBMITTED}`);
            dispatch(setData({property: "replacementRequest", value: initialReplacementRequestState}));
        }

    }, [isCreateReplacementRequestError, isCreateReplacementRequestSuccess]);

    useEffect(() => {
        if (isCreateReplacementRequestLoading) {
            window.scrollTo(0, 0);
        }
    }, [isCreateReplacementRequestLoading])

    if (isCreateReplacementRequestLoading) {
        return (
            <div className="form-demo p-2">
                <div className="flex justify-content-center">
                    <div className="card" style={{backgroundColor: "white", padding: 10, borderRadius: 10}}>
                        <ProgressSpinner style={{display: "block"}}/>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="form-demo p-2">
            <div className="flex justify-content-center">
                <div className="card" style={{backgroundColor: "white", padding: 10, borderRadius: 10}}>
                    <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                        <Image src="/mwzps.png" width="200" style={{marginRight: 10}}/>
                        <h2 className="text-center">Zgłoś zastępstwo</h2>
                    </div>

                    {!!errorMessage ? <Message style={{width: "100%"}} text={errorMessage} severity="error"/> : null}

                    <Form onSubmit={onCreateRequestSubmit} initialValues={{
                        matchUrl: replacementRequest.matchUrl,
                        refereeEmail: replacementRequest.refereeEmail,
                        replacementType: replacementRequest.replacementType,
                        additionalInformation: replacementRequest.additionalInformation
                    }} validate={validate} render={({handleSubmit}) => (
                        <form onSubmit={handleSubmit} className="p-fluid">

                            <Field name="matchUrl" render={({input, meta}) => (
                                <div className="field">
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-link"/>
                                        <InputText id="matchUrl" {...input}
                                                   className={classNames({
                                                       "p-invalid": isFormFieldValid(meta),
                                                       "p-inputtext-lg": true
                                                   })}/>
                                        <label htmlFor="matchUrl"
                                               className={classNames({"p-error": isFormFieldValid(meta)})}>Link do obsady *</label>
                                    </span>
                                    {getFormErrorMessage(meta)}
                                </div>
                            )}/>

                            <Field name="refereeEmail" render={({input, meta}) => (
                                <div className="field">
                                    <span className="p-float-label p-input-icon-right">
                                        <i className="pi pi-envelope"/>
                                        <InputText id="refereeEmail" {...input}
                                                   className={classNames({
                                                       "p-invalid": isFormFieldValid(meta),
                                                       "p-inputtext-lg": true
                                                   })}/>
                                        <label htmlFor="refereeEmail"
                                               className={classNames({"p-error": isFormFieldValid(meta)})}>Twój adres email *</label>
                                    </span>
                                    {getFormErrorMessage(meta)}
                                </div>
                            )}/>

                            <Field name="replacementType" render={({input, meta}) => (
                                <div className="field">
                                    <span className="p-float-label p-inputtext-lg">
                                        <Dropdown id="replacementType" {...input} options={[{
                                            value: "WARSAW",
                                            label: "Warszawa i okolice"
                                        }, {value: "RADOM", label: "Radom i okolice"}]} optionLabel="label"
                                                  optionValue="value" className={classNames({
                                            "p-invalid": isFormFieldValid(meta),
                                            "p-inputtext-lg": true
                                        })}/>
                                        <label htmlFor="replacementType"
                                               className={classNames({"p-error": isFormFieldValid(meta)})}>Region *</label>
                                    </span>
                                </div>
                            )}/>

                            <Field name="additionalInformation" render={({input, meta}) => (
                                <div className="field">
                                    <span className="p-float-label p-input-icon-right">
                                        <InputText id="additionalInformation" {...input}
                                                   className={classNames({
                                                       "p-invalid": isFormFieldValid(meta),
                                                       "p-inputtext-lg": true
                                                   })}/>
                                        <label htmlFor="additionalInformation"
                                               className={classNames({"p-error": isFormFieldValid(meta)})}>Dodatkowe informacje</label>
                                    </span>
                                    {getFormErrorMessage(meta)}
                                </div>
                            )}/>

                            <Button type="submit" label="Zgłoś" className="mt-2"/>
                        </form>
                    )}/>
                </div>
            </div>
        </div>
    );
};

export default CreateRequest;